export const CHANGE_FILTER = 'DAILY_ACTIVITY_CHANGE_FILTER'
export const DATA_RECEIVED = 'DAILY_ACTIVITY_DATA_RECEIVED'

export const makeChangeFilter = (newFilter) => ({ type: CHANGE_FILTER, filter: newFilter })
export const makeDataReceived = (newData) => ({ type: DATA_RECEIVED, data: newData })

export const STATUS_DATA_REQUESTED = 'DATA_REQUESTED'
export const STATUS_DATA_RECEIVED = 'DATA_RECEIVED'
